import React from 'react';
import { useStorageUrl } from '../utils/storageMedia';

export default function ResolvedStorageImage({
  path = '',
  alt = '',
  className = '',
  fallback = null,
  ...props
}) {
  const url = useStorageUrl(path);
  if (!url) return fallback;
  return <img src={url} alt={alt} className={className} {...props} />;
}
